import { render, staticRenderFns } from "./CertTag.vue?vue&type=template&id=5ad451cf&scoped=true"
import script from "./CertTag.vue?vue&type=script&lang=js"
export * from "./CertTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad451cf",
  null
  
)

export default component.exports